import { Tab, TabList, Tabs } from '@wartek-id/tabs'

import type { TabFilterRoles } from 'types/kinerja-ks'
import type { FC } from 'react'

export type TabsKsTabDetail = { name: TabFilterRoles; index: number }

export type TabsKsGuruProps = {
  hideTabGuru?: boolean
  defaultIndex?: number
  counters?: Record<TabFilterRoles, number>
  onChange?: (props: TabsKsTabDetail) => void
}

// Return tab detail based on index
const getTabDetail = (index: number): TabsKsTabDetail => {
  if (index === 1) return { name: 'GURU', index }
  return { name: 'KS', index }
}

const TabsKsGuru: FC<TabsKsGuruProps> = ({
  hideTabGuru = false,
  defaultIndex = 0,
  counters,
  onChange,
}) => {
  const showCounter = !!counters
  return (
    <Tabs
      defaultIndex={defaultIndex}
      onChange={(index) => onChange?.(getTabDetail(index))}
      className="w-full"
    >
      <TabList
        className="justify-evenly"
        style={{ boxShadow: '0px 2px 1px 0px #0000000D' }}
      >
        <Tab>Kepala Sekolah {showCounter && `(${counters?.KS || 0})`}</Tab>
        {!hideTabGuru && (
          <Tab>Guru {showCounter && `(${counters?.GURU || 0})`}</Tab>
        )}
      </TabList>
    </Tabs>
  )
}

export default TabsKsGuru
